import { Icon } from "@synergy/icons";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Theme from "../../../../../styles/Theme/Theme";
import Button from "../../../Atomics/Button";
import { MapCreateIncidentModal } from "../MapCreateIncidentModal/MapCreateIncidentModal";

const OverlayStyles = styled.div`
  /* height: Calc(100vh - 152px); */
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  pointer-events: none;
`;

const TopbBar = styled.div`
  display: flex;
  align-items: center;
  background-color: ${Theme.color.white};
  height: 78px;
  padding: 0 24px;
  justify-content: space-between;
  pointer-events: auto;

  .icon {
    cursor: pointer;
  }
`;

const BottomBar = styled.div`
    display: flex;
    align-items: center;
    background-color: ${Theme.color.white};
    height: 78px;
    gap: 16px;
    justify-content: flex-end;
    padding: 0 24px;
    pointer-events: auto;
`;

export const CreateIncidentsOverlay = ({ close, mapClickCoordinates, addNewIncidentToMap }) => {
    const { t } = useTranslation();
    const [createIncidentModal, setCreateIncidentModal] = useState(false);

    return (
        <>
            <OverlayStyles className="deloitte">
                <TopbBar>
                    <p>{t('button.create_incident')}</p>
                    <div onClick={close}>
                        <Icon icon='Close' color="black" iconsize="xs" className='icon' />
                    </div>
                </TopbBar>
                <BottomBar>
                    {/* <Button size='xxs' $backgroundColor={Theme.color['white']} border='1px solid black' $color='black' $onHoverBackgroundColor='black' $onHoverColor='white'>{t('clear')}</Button> */}
                    <Button size='xxs' $backgroundColor={Theme.color['blue-4']} onClick={() => setCreateIncidentModal(true)} disabled={!mapClickCoordinates}>{t('button.create_incident')} <Icon icon='Plus' color="black" iconsize="xs" /></Button>
                </BottomBar>
            </OverlayStyles>

            <MapCreateIncidentModal isCreateIncidentModalOpen={createIncidentModal} setCreateIncidentModal={setCreateIncidentModal}
                mapClickCoordinates={mapClickCoordinates} addNewIncidentToMap={addNewIncidentToMap}
                handleCreateIncidentSuccess={() => { close(); }}
            />
        </>
    )
};